"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage/ErrorMessage"));
var _richtextEditor = require("./richtextEditor.style");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function RichText(_a) {
  var {
      value,
      disabled,
      error,
      errorMessage,
      maxLength,
      setOptions = {},
      className = 'richTextEditor',
      id,
      fit = 'medium',
      content = ''
    } = _a,
    props = __rest(_a, ["value", "disabled", "error", "errorMessage", "maxLength", "setOptions", "className", "id", "fit", "content"]);
  const [dynamic, setDynamic] = (0, _react.useState)(null);
  const editor = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const loadDynamic = () => __awaiter(this, void 0, void 0, function* () {
      const x = yield Promise.resolve().then(() => _interopRequireWildcard(require('suneditor-react')));
      setDynamic(x);
    });
    loadDynamic();
  }, []);
  if (!dynamic) {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  const getSunEditorInstance = sunEditor => {
    editor.current = sunEditor;
    if (content) {
      // suneditor removes all div tags from passed content, to tackle this we are replacing div with p tags
      let formattedContent = content.replaceAll('<div', '<p');
      formattedContent = formattedContent.replaceAll('</div>', '</p>');
      sunEditor.setContents(formattedContent);
    }
  };
  return (0, _jsxRuntime.jsxs)(_richtextEditor.Components.Wrapper, (0, _extends2["default"])({
    className: "".concat(className, "-wrapper"),
    id: id
  }, {
    children: [(0, _jsxRuntime.jsx)(dynamic["default"], (0, _extends2["default"])({}, props, {
      defaultValue: value,
      disable: disabled,
      getSunEditorInstance: getSunEditorInstance,
      setDefaultStyle: "font-family: 'Maersk Text' ; font-size: ".concat(fit === 'small' ? '14px' : '16px', ";"),
      setOptions: (0, _extends2["default"])((0, _extends2["default"])({}, setOptions), {
        maxCharCount: maxLength,
        charCounter: !!maxLength,
        className: className
      })
    })), error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], {
      errorMessage: errorMessage
    })]
  }));
}
var _default = exports["default"] = RichText;